<template>
    <div>
        <div class="mb-0.5">
            <div class="flex items-center gap-2 text-gray-500">
                <Icon
                    :name="iconName"
                    class="w-3.5 h-3.5"
                />
                <span class="uppercase font-semibold text-xs">
                    {{ title }}
                </span>
            </div>
        </div>
        <div>
            <div class="pl-3.5 ml-2">
                <slot />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import Icon from '@/Shared/Component/Icon.vue'

    const props = defineProps({
        title: {
            type: String,
            required: true,
        },
        iconName: {
            type: String,
            required: true,
        },
    })
</script>
